import type { AuthSessionUser } from '../auth/types';
import type { Session } from './types';

export function presenterKey(value: unknown) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function isSessionPresenter(session: Pick<Session, 'presenters'>, user: AuthSessionUser | null | undefined) {
  if (!user?.sub) return false;

  const userKey = presenterKey(user.displayName);
  return (session.presenters ?? []).some((presenter) => {
    if (presenter.profileId && presenter.profileId === user.sub) return true;
    const keys = [presenter.presenterKey, presenterKey(presenter.name)].filter(Boolean);
    return Boolean(userKey && keys.includes(userKey));
  });
}

export function isPresenterSupport(
  user: AuthSessionUser | null | undefined,
  conferenceId?: string | null
) {
  if (user?.presenterSupport !== true) return false;
  const scopedConferenceId = String(user.presenterConferenceId || '').trim();
  const requestedConferenceId = String(conferenceId || '').trim();
  return !requestedConferenceId || !scopedConferenceId || scopedConferenceId === requestedConferenceId;
}
